import { observer } from "mobx-react-lite";
import Layout, { Body, Item, Control } from "../cmp/layout";
import Button from "../cmp/button";
import Field from "../cmp/field";
import useNav from "../hook/nav";
import usePartner from "./hook";
import Dict from "../cmp/dict";
import Phone from "./phone";
import useModal from "../hook/modal";

function Signup({ data }) {
	const { login } = useNav();
	const { show, open, close, ref } = useModal();
	const { d, wait, submit, value, handlers, err } = usePartner();

	return <Layout id='signup' title='Регистрация партнёра' onSubmit={submit}>
		<Body>
			<Item>
				<Field err={err.source} label='Тип партнёрства' text='Список' icon='pin' type='layer1' placeholder="Выберите из" disabledInput value={d} onChange={handlers.source} onClick={open} />
			</Item>
			<Item>
				<Field err={err.login} label='Логин' autoComplete='username' icon='user' type='layer1' placeholder='Введите логин' value={value.login} onChange={handlers.login} />
				<Field err={err.password} label='Пароль' autoComplete='new-password' content='password' icon='key' type='layer1' placeholder='Введите пароль' value={value.password} onChange={handlers.password} />
				<Field err={err.password2} label='Повторите пароль' autoComplete='new-password' content='password' icon='key' type='layer1' placeholder='Введите пароль' value={value.password2} onChange={handlers.password2} />
				<Phone value={value.phone} setValue={handlers.phone} err={err.phone} />
			</Item>
		</Body>
		<Control>
			<Button disabled={wait} children='Назад' type='base-reverse' onClick={login} />
			<Button disabled={wait || hasError(err)} children='Зарегистрироваться' type='base' onClick={submit} />
		</Control>
		{show && <Dict code='partShip' info='company' data={data} close={close} ref={ref} value={value.source} onSelect={handlers.source} />}
	</Layout>
}

export default observer(Signup);

function hasError(o) {
	const arr = Object.values(o);
	return arr.some(e => e);
}